import {useLocation, useNavigate} from "react-router-dom";
import {isAccessGranted, ROUTE_PATHS} from "../../Config/Router/Routes";
import {useEffect} from "react";

export default function RouteRolesChecker() {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    // Usar useEffect para manejar efectos secundarios
    useEffect(() => {
        if (!isAccessGranted(pathname)) {
            navigate('error-404');
        }
    }, [pathname, navigate]);

    return null;
}
